<script setup lang="ts">
import type { QuizQuestionAnswerSequencing } from '@/core/domain/quiz/QuizQuestionAnswer.ts'

defineProps<{
  answer: QuizQuestionAnswerSequencing
}>()
</script>

<template>
  <div
    class="flex flex-1 flex-row justify-start rounded-lg border border-solid p-0"
    :class="$style.SequencingAnswer"
  >
    <div
      class="bg-surface-100 dark:bg-surface-700 border-surface-400 dark:border-surface-400 w-12 flex-initial rounded-l-lg border-r py-2 text-center"
      :class="$style.prefix"
    >
      <p>{{ answer.order }}</p>
    </div>
    <p class="flex-1 grow px-2 py-2">{{ answer.data.value }}</p>
  </div>
</template>

<style module>
.SequencingAnswer {
  border-color: var(--surface-400);

  p {
    cursor: default;
  }

  &.prefix {
    width: 50px;
    max-width: 30px;
    border-right: 1px solid black;
    padding-left: 4rem;
    background-color: var(--surface-900);
  }
}
</style>
